import React from "react";

export default function Complisttopwin() {
  return (
    <div>
      <div className="mt-3">
        <p className="text-center text-secondary fw-bold">Top Win Kosong</p>
      </div>
    </div>
  );
}
